import { action, observable } from 'mobx';
import { ProjectsStore } from './ProjectsStore';
import { appConfig } from 'cd-eft/config/AppConfig';
import { FeatureLayer, GroupLayer } from 'cd-eft/utils/esriTypes';

class AlignmentStoreProjectsStore extends ProjectsStore {
  constructor(private alignmentdesignstore: any) {
    super(alignmentdesignstore);
  }
}

export interface IAlignmentObject {
  designElementId: number;
  editingStatus: string;
  surfaceDefId: number;
  surveyId: string;
  alignmentName: string;
  alignmentId: number;
  alignmentEntryMethod: string;
  alignmentAutoGrow: string;
  alignmentIncreasing: string;
  alignmentAutoCreated: number;
  beginningX: number;
  beginningY: number;
  surveyCoordinateSystem: number;
  alignmentApplyCurves: string;
  beginningStationDis: number;
  alignmentStations: IAlignmentStation[];
  alignmentXY?: any;
  curvedAlignmentXY?: any;
}

export interface IAlignmentStation {
  angleType: number;
  angle: number;
  curveType: number;
  curveValue: number;
  stationDistance: number;
  distance: number;
  x: number;
  y: number;
  z: number;
  description: string;
  editingStatus: string;
  stationName: number;
}

export class AlignmentDesignStore {
  constructor(private appStore: any) {
    this.projectsStore = new AlignmentStoreProjectsStore(this);
    this.init();
  }

  @observable projectsStore: AlignmentStoreProjectsStore;
  @observable alignmentObject!: IAlignmentObject;
  @observable alignmentStation!: IAlignmentStation;
  @observable chooseCenter: boolean = false; // ?
  @observable summaryTable: any = []; // short list of alignments
  @observable designElementsDataArray: any = []; // list of alignments with json data
  @observable designElementsDataMap: any = new Map(); // map of alignments with json data id: { data }
  @observable selectedAlignments: any = new Set(); // list of selected alignments Ids
  @observable displayedAlignments: any = new Set(); // list of displayed alignments Ids
  @observable unsavedAlignments: any = new Set(); // list of unsaved alignments Ids
  @observable updateCurveSave = true;
  @observable disableSaveAlignment: boolean = true;
  @observable addElementModalOpen: boolean = false;
  @observable alignmentCopyModalOpen: boolean = false;
  @observable begginingStation: string = '0';
  @observable currentElement: any = {};
  @observable currentTab: string = 'Summary'; // ['Summary', 'New', 'Edit']
  @action resetTabs() {
    this.currentTab = 'Summary';
  }
  // delete single alignment station -->
  @observable deleteAlStDialoglIsOpen: boolean = false;
  @observable alignmentStationToDelete: any = {};
  @action.bound toggleDeleteAlStDialog() {
    this.deleteAlStDialoglIsOpen = !this.deleteAlStDialoglIsOpen;
  }

  // Loading and Errors -->
  @observable isLoading: boolean = false;
  @observable error: boolean = false;
  @observable errorMsg: string = '';
  @action.bound setError(msg: string) {
    if (msg !== '') {
      this.error = true;
      this.errorMsg = msg;
      this.isLoading = false;
    } else {
      this.error = false;
      this.errorMsg = '';
      this.isLoading = false;
    }
  }
  // <-- Loading and Errors

  @action reset() {
    this.init();
  }

  @action resetDuplication() {
    this.selectedAlignments = new Set();
    this.displayedAlignments = new Set();
    this.unsavedAlignments = new Set();
  }

  @action resetCurrentObject() {
    this.currentElement = { element: '', name: '', id: '', type: '' };
    this.alignmentObject = { ...this.initialAlignmentObject };
    this.resetTabs();
  }

  @action init() {
    this.resetCurrentObject();
    this.resetDuplication();
    this.setError('');
    this.resetTabs();
    this.summaryTable = [];
    this.designElementsDataArray = [];
    this.designElementsDataMap = new Map();
    this.chooseCenter = false;
    this.isLoading = false;
    this.currentTab = 'Summary';
    this.addElementModalOpen = false;
    this.alignmentCopyModalOpen = false;
    this.deleteAlStDialoglIsOpen = false;
    this.alignmentStationToDelete = {};
    this.updateCurveSave = true;
  }

  initialAlignmentStation: IAlignmentStation = {
    angleType: 0,
    angle: 0.0,
    curveType: 0,
    curveValue: 0.0,
    stationDistance: 0.0,
    distance: 0.0,
    x: 0.0,
    y: 0.0,
    z: 0.0,
    description: 'alignment station',
    editingStatus: 'add',
    stationName: 0,
  };

  @action removeAlignmentLabelsLayer(mapview:any): void {
    if (mapview && mapview.map) {
      const groupLayer = mapview.map.findLayerById(`alignment${this.alignmentObject.alignmentId}`) as GroupLayer;
      if (groupLayer) {
        const reachStationLayer = groupLayer.findLayerById('AlignmentStationLabels') as FeatureLayer;
        if (reachStationLayer) {
          const removedLayer = groupLayer.remove(reachStationLayer);
          if (removedLayer) removedLayer.destroy();
        }
      }
    }

    // const labels = mapview?.map.findLayerById('AlignmentStationLabels');
    // if (labels) mapview?.map.remove(labels);
    // labels?.destroy();

    const label = mapview?.map.findLayerById('auto_alignment_label');
    if (label) mapview?.map.remove(label);
    label?.destroy();
  }

  @action resetSelectedAlignments() {
    this.selectedAlignments.clear();
    this.selectedAlignments = new Set();
  }

  initialAlignmentObject: IAlignmentObject = {
    designElementId: 0,
    editingStatus: 'add',
    surfaceDefId: 1, // TEMPORARY
    surveyId: '',
    alignmentName: '',
    alignmentId: 0,
    alignmentEntryMethod: 'Coordinates', // 'AngleDistance'
    alignmentAutoGrow: 'true',
    alignmentIncreasing: 'true',
    alignmentAutoCreated: 0,
    beginningX: 0,
    beginningY: 0,
    surveyCoordinateSystem: appConfig.tempHardCodes.wkid,
    alignmentApplyCurves: 'false',
    beginningStationDis: 0,
    alignmentStations: [{ ...this.initialAlignmentStation }],
  };
}
